var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTonga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4297C24.8366 32.4297 32 25.2662 32 16.4297C32 7.59313 24.8366 0.429688 16 0.429688C7.16344 0.429688 0 7.59313 0 16.4297C0 25.2662 7.16344 32.4297 16 32.4297Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 8.77737V6.69043H8.3478V8.77737H6.26086V10.8644H8.3478V12.9513H10.4348V10.8644H12.5217V8.77737H10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.429688V16.4297C7.1635 16.4298 3.65156 16.4297 0 16.4298C0 25.2662 7.1635 32.4297 16 32.4297C24.8365 32.4297 32 25.2662 32 16.4297C32 7.59319 24.8365 0.429688 16 0.429688Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.429688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTonga);
export default __webpack_public_path__ + "static/media/flag_tonga.ec9b1c25961c3e17550f07178d86d8a9.svg";
export { ForwardRef as ReactComponent };